import { render, staticRenderFns } from "./VerifyContract.vue?vue&type=template&id=380b8e01&lang=pug"
import script from "./VerifyContract.vue?vue&type=script&lang=js"
export * from "./VerifyContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports